import { Card, CardHeader, Typography, Button } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import { setDialog } from "../../../../../app/slices/posField";
import { BiCategoryAlt } from "react-icons/bi";
import PosFieldForm from "../../form";
import Permission from "../../../../../components/userPermission/userPermission";

const PosFieldHeader = () => {
  const dispatch = useDispatch();
  const _PosField = useSelector((state) => state.posField);

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            النشاط التجاري لنقاط البيع
          </Typography>
        }
        avatar={<BiCategoryAlt size={20} />}
        action={
          <Permission permission="pos_field_edit">
            <Button
              variant="contained"
              color="primary"
              size="medium"
              startIcon={<IoIosAddCircleOutline />}
              onClick={() => dispatch(setDialog())}
            >
              إضافة نشاط تجاري
            </Button>
          </Permission>
        }
      />
      {_PosField.posField.dialog ? <PosFieldForm /> : null}
    </Card>
  );
};

export default PosFieldHeader;
